import '@/lib/typedef';
import client from '@/lib/http-client-connection';

const endpoint = '/submission';
const publicToken = process.env.PUBLIC_API_SECURITY_CODE || 'ZAwXDvtlfT4b242AF2bvrptvxvtZZjj0'; // TODO: move to be

export default {
	getOrderDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}/details?store_info=1&skip_deleted=true`;

		const headers = {
			'Accept-Encoding': 'gzip',
			Authorization: `Token ${publicToken}`,
		};

		client.get(url, { headers })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
